import React, { MouseEvent, ChangeEvent } from "react";
import "./TeacherAudioCard.css";
import ReactPlayer from "react-player";
import { Grid, IconButton, Typography } from "@material-ui/core";
import UploadService from "../../../services/upload/UploadService";
import { Pause, PlayArrow } from "@material-ui/icons";
import handleDuration from "../../../services/recorder/HandleDuration";
import SeekSlider from "../../SeekSlider";

interface AudioCardProps {
  audioPath: string;
  isInstructions?: boolean;
}

interface AudioCardState {
  audioUrl: string;
  isPlaying: boolean;
  duration: number;
  currentTime: number;
}

class TeacherAudioCard extends React.Component<AudioCardProps, AudioCardState> {
  setAudioRef: React.LegacyRef<ReactPlayer>;
  audioRef: ReactPlayer | null;

  constructor(props: AudioCardProps) {
    super(props);
    this.state = {
      audioUrl: "",
      isPlaying: false,
      duration: 0,
      currentTime: 0,
    };
    this.audioRef = null;
    this.setAudioRef = player => (this.audioRef = player);
  }

  override componentDidMount() {
    UploadService.getCommentAudio(this.props.audioPath).then(async url => {
      this.setState({ audioUrl: url });
    });
  }

  loadDuration = (duration: number) => this.setState({ duration });

  onEnded = () => this.setState({ isPlaying: false });

  handleAudio = (_event: MouseEvent) =>
    this.setState(state => ({
      isPlaying: !state.isPlaying,
    }));

  onProgress = ({ playedSeconds }: { playedSeconds: number }) => this.setState({ currentTime: playedSeconds });

  onSeek = (_ev: ChangeEvent<{}>, value: number | number[]) => {
    if (this.audioRef && typeof value === "number") {
      this.audioRef.seekTo(value, "seconds");
      this.setState({ currentTime: value });
    }
  };

  override render = () => (
    <div className="audioCard">
      <ReactPlayer
        ref={this.setAudioRef}
        width="0px"
        height="0px"
        url={this.state.audioUrl}
        playing={this.state.isPlaying}
        onDuration={this.loadDuration}
        onProgress={this.onProgress}
        onEnded={this.onEnded}
      />
      <Typography className="teachersInstructions">
        {" "}
        Teacher's {this.props.isInstructions ? "Instructions" : "Example"}
      </Typography>
      <Grid container direction="row" justify="space-between" alignItems="center">
        <div className="leftText">
          <IconButton onClick={this.handleAudio} className="playPauseButton">
            {this.state.isPlaying ? <Pause /> : <PlayArrow />}{" "}
          </IconButton>
          <SeekSlider currentTime={this.state.currentTime} maxDuration={this.state.duration} onChange={this.onSeek} />
        </div>
        <Typography className="audioTime">{handleDuration(this.state.duration)}</Typography>
      </Grid>
    </div>
  );
}

export default TeacherAudioCard;
